<template>
    <v-icon :icon="icon" :color="color" />
</template>

<script setup>
    import { computed } from 'vue';
    import { mdiCheck, mdiClose } from '@mdi/js';

    const props = defineProps(['params']);

    const isTrue = computed(() => {
        const value = props.params.value;

        if (typeof value === 'boolean')
            return value;

        return ['true', 'yes'].indexOf((value ?? '').toString().toLowerCase()) > -1;
    });

    const icon = computed(() => isTrue.value ? mdiCheck : mdiClose);

    const color = computed(() => isTrue.value ? 'success' : 'error');
</script>
